{
  "title": "Container",
  "summary": {
    "total": "Container gesamt",
    "running": "Laufend"
  },
  "empty": "Noch keine Container.",
  "loading": "Lade…",
  "status": {
    "created": "Erstellt",
    "starting": "Startet…",
    "running": "Läuft",
    "stopping": "Stoppt…",
    "stopped": "Gestoppt",
    "error": "Fehler"
  },
  "tabs": {
    "config": "Config",
    "console": "Konsole",
    "logs": "Logs",
    "stats": "Stats",
    "ports": "Ports"
  },
  "spec": {
    "cpu_unlimited": "CPU ∞",
    "ram_unlimited": "RAM ∞",
    "cpu_limit": "Limit: {{cpu}} vCPU",
    "no_limit": "Kein Limit",
    "no_ipv4": "(keine IPv4)"
  },
  "stats": {
    "not_running": "Container läuft nicht — keine Live-Stats."
  },
  "logs": {
    "lifecycle_title": "Lifecycle-Log (incus info --show-log)",
    "auto_refresh": "Auto-Refresh",
    "empty": "(leer)",
    "tip": "Tipp:"
  },
  "detail": {
    "loading": "Lade…",
    "back": "Zurück zu Container",
    "refresh": "Aktualisieren",
    "new": "Neuer Container",
    "subtitle": "LXC via incus — leichtgewichtige Dienste in br0, ohne VM-Overhead.",
    "console_not_running": "Container läuft nicht — Konsole nicht verfügbar."
  },
  "console": {
    "error_not_logged_in": "Nicht angemeldet",
    "error_connection": "Verbindung fehlgeschlagen",
    "error_unauthorized": "Nicht autorisiert",
    "error_not_found": "Container nicht gefunden",
    "error_not_running": "Container läuft nicht",
    "error_backend": "Backend-Fehler"
  },
  "create": {
    "title": "Container erstellen",
    "submit": "Container erstellen",
    "submitting": "Erstelle…",
    "field_name": "Name",
    "field_name_hint": "z.B. searxng, vaultwarden, linkding",
    "field_desc": "Beschreibung (optional)",
    "field_image": "Image",
    "field_cpu": "CPU-Limit (optional)",
    "field_cpu_hint": "Vorschlag – leer lassen = unbegrenzt",
    "field_ram": "RAM-Limit MB (optional)",
    "field_ram_hint": "Vorschlag – leer lassen = unbegrenzt",
    "field_network": "Netzwerk",
    "network_bridged_title": "Bridged (br0)",
    "network_bridged_desc": "Container bekommt DHCP-IP aus dem LAN — wie VMs",
    "network_isolated_title": "Isoliert",
    "network_isolated_desc": "Kein Netzwerk-Zugang",
    "custom_image_label": "Custom Image-Alias eingeben",
    "back_to_list": "← Quick-Liste",
    "error_image_missing": "Image fehlt",
    "error_name_invalid": "Name: 1-63 Zeichen, beginnt mit Buchstabe, nur a-z A-Z 0-9 -",
    "remote_placement_note": "Remote-Platzierung: Der Container läuft dauerhaft auf dem gewählten Node (Admin-only). Eine Migration ist in V1 nicht vorgesehen.",
    "network_nat_title": "NAT (eigene IP)",
    "network_nat_desc": "Internes Netz mit fester IP, Dienste über Portfreigaben – für VPS",
    "network_unavailable": "Auf diesem Server nicht verfügbar"
  },
  "edit": {
    "field_name": "Name",
    "field_desc": "Beschreibung",
    "field_cpu": "CPU-Kerne",
    "field_ram": "RAM (MB)",
    "field_image_readonly": "Image (read-only — Re-Create für anderes Image)",
    "error": "Fehler"
  },
  "ports": {
    "loading": "Lade Portfreigaben…",
    "only_nat": "Portfreigaben gibt es nur für Container im NAT-Netz.",
    "ip": "Interne IP:",
    "col_label": "Freigabe",
    "col_protocol": "Protokoll",
    "col_ports": "außen → innen",
    "col_scope": "Reichweite",
    "empty": "Noch keine Portfreigaben.",
    "label_ph": "Name, z. B. Minecraft",
    "host_start_ph": "Port außen",
    "host_end_ph": "bis (optional)",
    "inner_ph": "Port innen (optional)",
    "scope_public": "Öffentlich",
    "scope_tailnet": "Nur Tailnet",
    "scope_off": "Aus",
    "add": "Freigeben",
    "delete_confirm": "Portfreigabe löschen?",
    "hint_provider": "Öffentliche Ports müssen zusätzlich in der Firewall deines Server-Anbieters offen sein.",
    "hint_udp": "Für UDP braucht die Anbieter-Firewall eine eigene UDP-Regel.",
    "hint_reserved": "Gesperrt: Ports unter 1024 sowie 3000, 3001, 5432, 6379, 8001, 8888, 9000, 9001, 10000, 41641. Max. 100 Ports pro Freigabe. Öffentlich freigeben dürfen nur Admins."
  }
}
